<template>
    <div class="h-full overflow-visible pb-4 flex flex-col">
        <div class="tab-headers">
            <div
                v-for="tab in enabledTabs"
                :key="tab.key"
                class="tab-header"
                :class="{selected: tab.key === (selectedTab && selectedTab.key)}"
                :data-cy="tab['data-cy']"
                @click="setSelectedTab(tab)"
            >
                {{ tab.title }}
            </div>
        </div>
        <div class="overflow-y-visible flex flex-col grow w-full">
            <component
                :is="selectedTab.component"
                v-if="selectedTab && selectedTab.component"
                class="p-2 pb-0 bg-base-100 rounded rounded-tl-none shadow w-full overflow-auto scrollbar-gutter"
            />
        </div>
    </div>
</template>

<script setup lang="ts">

import {computed, PropType} from 'vue'
import {TabDefinition} from '@/tabs/TabDefinition.type'

const props = defineProps({
    tabs: {
        type: Array as PropType<TabDefinition[]>,
        default: () => []
    }
})

const selectedTab = defineModel({
    type: Object as () => TabDefinition,
    required: true
})

const enabledTabs = computed(()=> {
    return props.tabs.filter(tab => tab.enabled)
})

const setSelectedTab = (tab: TabDefinition) => {
    selectedTab.value = tab
}

</script>

<style scoped>
@reference "@/index.css";
@reference "tailwindcss";

.tab-headers {
    @apply flex w-fit text-lg bg-none;
    .tab-header {
        @apply bg-base-200;
        @apply cursor-pointer px-4 py-1;
        @apply shadow-sm;
        @apply first-of-type:rounded-tl last-of-type:rounded-tr;

        &.selected {
            @apply bg-base-100;
            @apply shadow-none;
            @apply text-primary;
        }
    }
}

.scrollbar-gutter {
    scrollbar-gutter: stable;
    scrollbar-width: thin;
}
</style>